module.exports = __webpack_public_path__ + "img/money.f88a4504.svg";